import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';

export const useGoodsAwards = () => {
  const goodsSno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsAwards(goodsSno),
    queryFn: () => goodsService.getGoodsAwards(goodsSno),
  });
};
